export const SDK_VERSION = '7.29.0';
